import { WEB_GL_LAYER_ID } from '@pkg/webgl/WebGLLayer';

export const useWebGlLayerZIndex = () => {
    const getLayerElement = () => document.getElementById(WEB_GL_LAYER_ID);

    const setLayerZIndex = (zIndex: number) => {
        const element = getLayerElement();

        if (element) {
            element.style.zIndex = zIndex.toString();
        }
    };

    const setLayerToTop = () => {
        setLayerZIndex(10);
    };

    const setDefaultLayerZIndex = () => {
        const element = getLayerElement();

        if (element) {
            element.style.zIndex = '1';
        }
    };

    const hideLayer = () => {
        const element = getLayerElement();

        if (element) {
            element.style.display = 'none';
        }
    };

    const showLayer = () => {
        const element = getLayerElement();

        if (element) {
            element.style.display = 'block';
        }
    };

    return { setLayerToTop, setDefaultLayerZIndex, setLayerZIndex, hideLayer, showLayer };
};
